var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvoryGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0571 3.52677L6.20587 2.37576L7.7952 3.96819L5.86673 5.90209L6.75782 6.79492L9.57737 3.96819L6.20587 0.590101L4.16602 2.63394L5.0571 3.52677Z",
    fill: "#D4AD89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1304 6.8275L1.69739 5.10681L0 6.80751L1.72399 8.5332L5.1304 6.8275Z",
    fill: "#D4AD89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67088 5.73242L3.37167 3.42873L2.60693 4.19662L5.67088 5.73242Z",
    fill: "#D4AD89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6333 9.44792L3.37144 10.1875L5.59085 7.96543L2.6333 9.44792Z",
    fill: "#D4AD89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50029 6.79984L8.37842 7.67969L9.25655 6.79984L8.37842 5.91999L7.50029 6.79984Z",
    fill: "#D4AD89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91732 10.5014L6.20578 11.2143L5.05368 10.0617L4.1626 10.9545L6.20578 13L7.80841 11.3942L6.91732 10.5014Z",
    fill: "#D4AD89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86719 7.68889L7.3152 9.13974L8.68675 10.5156L9.57783 9.6228L6.75661 6.79606L5.86719 7.68889Z",
    fill: "#D4AD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryGold);
export default __webpack_public_path__ + "static/media/IvoryGold.feb11742693b1018f322fa35ed617e04.svg";
export { ForwardRef as ReactComponent };